import React, { FC, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { BadgeContainer, Icon, Tag, Tooltip } from '@wmgtech/legato'

import { cn } from 'shared/utils'
import { formatDate } from 'shared/utils/formatDate'
import { userFullName } from 'shared/utils/userFullName'
import { ENABLED_FEATURES } from 'shared/utils/featureFlags'

import { GpsBadge } from 'components'
import { FollowButton } from 'modulesCommon/Follow/containers'

import { IProjectItemDetail } from './ProjectItemDetail.props'
import './ProjectItemDetail.scss'

const ProjectItemDetail: FC<IProjectItemDetail> = ({ project, unit, artistName, label, isSameLabel }) => {
  const nameColumnSpan = label ? 4 : 7
  const unitColumnSpan = label ? 3 : 4
  const isGlobalized = project?.parent?.global_status === 'PUBLISHED'

  const projectWithGPS = useMemo(() => project?.products?.find((product) => product.gps_status?.length), [project])

  return (
    <div className={cn('project-item', { 'project-item--archived': !project.active })}>
      <Link to={project.id} className="project-item__link" />
      <div className="sbx-row sbx-row-gutter-10 project-item__row">
        <div className="sbx-col-sm-1 project-item__first_col" />
        <div className={`sbx-col-sm-${nameColumnSpan} project-item__name`} >
          <div className="project-item__name">
            <span>{project.name}</span>
            {!project.active ? (
              <BadgeContainer containerStyle="outline" colorType="dark" size="sm">
                <Icon name="warning" />
                &nbsp;Project Archived
              </BadgeContainer>
            ) : null}
          </div>
        </div>
        <div className="sbx-col-sm-3" >
          <div>
            {project.products?.length} Product{project.products && project.products?.length !== 1 && 's'}
          </div>
          {projectWithGPS ? <GpsBadge gpsStatus={projectWithGPS.gps_status} coloredBackground /> : null}
        </div>
        {label ? (
          <div className="sbx-col-sm-2" >
            <Tag
              size={'xs'}
              removable={false}
              rounded
              text={label.alias}
              colorType={isSameLabel ? 'white' : 'dark'}
              containerStyle={isSameLabel ? 'outline' : 'solid'}
              className="project-item__tag"
              tooltip
              tooltipText={label.name}
            />
          </div>
        ) : null}
        <div className={`sbx-col-sm-${unitColumnSpan}`}>{unit}</div>
        <div className="sbx-col-sm-2" >
          {formatDate({ date: project.created_at, withTime: false })}
        </div>
        <div className="sbx-col-sm-3" >
          <Tooltip message="Contact PO" placement="top" colorType="dark">
            <a className="project-item__owner" href={`mailto:${project.user?.email}`}>
              {userFullName(project?.user)}
            </a>
          </Tooltip>
        </div>
        {ENABLED_FEATURES.GLOBALHUB && (
          <div className="sbx-col-sm-2 project-item__global" >
            {isGlobalized ? <Icon prefix="fas" name="badge-check" /> : null}
          </div>
        )}
        <div className="sbx-col-sm-2 project-item__follow" >
          <FollowButton
            projectId={project.id}
            userId={project.owner_id}
            projectName={`${artistName}, ${project?.name}`}
            disabled={!project.active}
          />
        </div>
      </div>
    </div>
  )
}
export default ProjectItemDetail
